//phrasebook
import phrasebookLoad from "../i18n";
const phrasebook = phrasebookLoad();

export const HeaderDropDown = [
  { id: "account", label: phrasebook.headerlinks.accounts },
  { id: "management", label: phrasebook.headerlinks.manage, always: true },
  // KC- disable administation header
  { id: "administration", label: phrasebook.headerlinks.administration },

  // { id: 'reporting', label: phrasebook.headerlinks.reporting },
  { id: "support", label: phrasebook.headerlinks.support, always: true },
  { id: "report", label: phrasebook.headerlinks.reports, always: true },

  // { id: 'notification', label: phrasebook.notifications.notifications },
];
// 110: [
//   { id: 'account', type: phrasebook.headerlinks.customers },
//   { id: 'inventory', type: phrasebook.headerlinks.manage },
//   { id: 'reporting', type: phrasebook.headerlinks.reporting },
//   { id: 'support', type: phrasebook.headerlinks.support }
// ],
// 120: [
//   { id: 'account', type: phrasebook.headerlinks.customers },
//   { id: 'inventory', type: phrasebook.headerlinks.manage },
//   { id: 'reporting', type: phrasebook.headerlinks.reporting },
//   { id: 'support', type: phrasebook.headerlinks.support }
// ],
// 200: [
//   { id: 'account', type: phrasebook.headerlinks.customers },
//   { id: 'inventory', type: phrasebook.headerlinks.manage },
//   { id: 'reporting', type: phrasebook.headerlinks.reporting },
//   { id: 'support', type: phrasebook.headerlinks.support }
// ]

// export const TeamDropDown = [
//   { id: 'salesteam', type: phrasebook.notifications.sales_team },
//   { id: 'productteam', type: phrasebook.notifications.product_team },
//   { id: 'operationsteam', type: phrasebook.notifications.operations_team },
//   { id: 'billingteam', type: phrasebook.notifications.billing_team },
// ]
export const CustomerDropDown = [
  phrasebook.headerlinks.customer_details,
  phrasebook.headerlinks.account_dsetails,
  phrasebook.headerlinks.sub_accounts,
  phrasebook.headerlinks.orders,
  phrasebook.headerlinks.invoices,
];
export const OrderingDropDown = [
  phrasebook.headerlinks.ordering,
  phrasebook.headerlinks.dnis,
  phrasebook.headerlinks.termination,
  phrasebook.numbers.number_information,
  phrasebook.headerlinks.pricing,
  phrasebook.headerlinks.service_restrictions,
  phrasebook.headerlinks.payment,
];
export const ReportingDropDown = [
  phrasebook.headerlinks.overview,
  phrasebook.headerlinks.call_statistics,
  phrasebook.headerlinks.call_records,
];
export const SupportDropDown = [
  phrasebook.headerlinks.tickets,
  phrasebook.headerlinks.contacts,
];
